<template>
  <div id="home_bg">
    <homeheader />
    <investments />
    <div v-if="appLogout">
      <v-snackbar v-model="showSnackBar" color="#00a972" right :timeout="timeout">
        <v-layout wrap>
          <v-flex xs12 sm12 md12 text-center>
            <span style="font-size:14px;font-weight:500">Account Activity</span>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <span style="font-size:14px;font-weight:500">Login: {{loginTime}}</span>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <span style="font-size:14px;font-weight:500">Logout: {{logoutTime}}</span>
          </v-flex>
        </v-layout>
        <v-btn text @click="showSnackBar = false">
          <v-icon style="color:white;">mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import store from "./../../store";
import axios from "axios";
import homeheader from "./../Home/homeHeader";
import investments from "./../Home/investments";

export default {
  components: {
    homeheader,
    investments
  },
  data() {
    return {
      timeout: 10000,
      loginTime: null,
      logoutTime: null,
      showSnackBar: false,
      showSnackBar2: false,
      userName: null,
      msg: null
    };
  },
  computed: {
    appLogout() {
      if (store.state.isLoggedOut) this.showSessionSnack();
      return store.state.isLoggedOut;
    }
  },
  methods: {
    showSessionSnack() {
      if (localStorage.getItem("isLoggedOut") == "true") {
        this.loginTime = this.formatTime(localStorage.getItem("loginTime"));
        this.logoutTime = this.formatTime(localStorage.getItem("logoutTime"));
        localStorage.removeItem("loginTime");
        localStorage.removeItem("logoutTime");
        localStorage.removeItem("isLoggedOut");
        this.showSnackBar = true;
      }
    },
    formatTime(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var newTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return newTime;
    },
    removeUser() {
      axios({
        method: "GET",
        url: "/remove/userbyusername",
        params: {
          code: "qscef",
          username: this.userName
        }
      }).then(response => {
        if (response.data.status) {
          this.msg = "Removed";
          this.showSnackBar2 = true;
        }
      });
    }
  }
};
</script>

<style>
#home_bg {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: contain;
  color: white;
}

@media only screen and (max-width: 800px) {
  #home_bg {
    /* background-image: url("../../assets/home_header.png"); */
    /* background-repeat: no-repeat; */
    background-size: cover;
    /* color: white; */
  }
}
</style>
